export const sortAlphaNumMeasureSort = (a: any, b: any) => a.measureName.localeCompare(b.measureName, 'en', { numeric: true })
